module.exports = __webpack_public_path__ + "img/Pest-Control-Man-2.3a4dcf1b.jpg";